var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReaderFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 17.5,
    fill: "#003D76",
    stroke: "#FFFDFC",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12H26V17M26 12L20.5 17.5M17 26H12V21M12 26L17.5 20.5",
    stroke: "#FFFDFC",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaderFullscreen);
export default __webpack_public_path__ + "static/media/reader_fullscreen.f9ddac8d4392d715457cdc1ad98277ee.svg";
export { ForwardRef as ReactComponent };